var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.99 2.02a1 1 0 0 0-1.278-.539L2.116 3.249a1 1 0 0 0-.635 1.044c.383 3.45 2.28 7.536 6.287 11.547l.01.01c4.014 4.013 8.103 5.913 11.557 6.296a1 1 0 0 0 1.044-.635l1.768-4.596a1 1 0 0 0-.54-1.278l-4.95-2.121a1 1 0 0 0-.93.075l-.477.304c-1.855 1.18-4.001 1.173-5.342-.159l-.008-.008c-1.34-1.34-1.35-3.492-.167-5.35l.303-.477a1 1 0 0 0 .076-.931L7.99 2.02z"
  })));
};
export default SvgCall;